import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { CryptoApi, RequestStrategyEnum, type GetWalletAddressesResponse, type WithSignal } from '@shared/api';

const getWalletAddressesEffect = createEffect(({ signal, ...request }: WithSignal<{ accountId: number }>) =>
  CryptoApi.getWalletAddresses(request.accountId, signal),
);
const clearEvent = createEvent();

const $dataStore = createStore<GetWalletAddressesResponse[]>([])
  .on(getWalletAddressesEffect.done, (_, data) => data.result.data || [])
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getWalletAddressesEffect.pending, (_, data) => data)
  .on(getWalletAddressesEffect.fail, (_, data) => ApiUtils.abortApiLoadingFailCaseTrigger(data.error))
  .on(getWalletAddressesEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getWalletAddressesEffect, () => null)
  .on(getWalletAddressesEffect.fail, () => 'Something went wrong while fetching Wallet Addresses. Please try again.')
  .on(getWalletAddressesEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

const getWalletAddressesApi = ApiUtils.wrapperApi(getWalletAddressesEffect, RequestStrategyEnum.Abort);
clearEvent.watch(() => getWalletAddressesApi.cancel());

export const $walletAddressesStore = {
  events: {
    getWalletAddresses: getWalletAddressesApi.trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
